import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Text = styled.span`
  color: ${({ color, theme }) => (color ? color : theme.color.gray_700)};
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
`;

const skBouncedelay = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 40% {
    transform: scale(1.0);
  }
`;

const Spinner = styled.div`
  z-index: 3;
  div {
    width: 12px;
    height: 12px;
    background-color: ${({ color, theme }) => (color ? color : theme.color.gray_700)};
    border-radius: 100%;
    display: inline-block;
    animation: ${skBouncedelay} 1.4s infinite ease-in-out both;
    margin: 4px;
    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }
`;

const Loading = ({ label, ...rest }) => (
  <Wrapper>
    <Spinner {...rest}>
      <div />
      <div />
      <div />
    </Spinner>
    {label ? <Text {...rest}>{label}</Text> : null}
  </Wrapper>
);

Loading.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
};

export default Loading;
